import { baseUrl, cleverUrl } from "@app/providers";

const CountriesList = ["United States"];
export const countriesList = CountriesList.map((each) => {
  return { label: each, value: each };
});

export const stateList = [
  {
    value: "AL",
    label: "Alabama",
  },
  {
    value: "AK",
    label: "Alaska",
  },
  {
    value: "AZ",
    label: "Arizona",
  },
  {
    value: "AR",
    label: "Arkansas",
  },
  {
    value: "CA",
    label: "California",
  },
  {
    value: "CO",
    label: "Colorado",
  },
  {
    value: "CT",
    label: "Connecticut",
  },
  {
    value: "DE",
    label: "Delaware",
  },
  {
    value: "DC",
    label: "District of Columbia",
  },
  {
    value: "FL",
    label: "Florida",
  },
  {
    value: "GA",
    label: "Georgia",
  },
  {
    value: "HI",
    label: "Hawaii",
  },
  {
    value: "ID",
    label: "Idaho",
  },
  {
    value: "IL",
    label: "Illinois",
  },
  {
    value: "IN",
    label: "Indiana",
  },
  {
    value: "IA",
    label: "Iowa",
  },
  {
    value: "KS",
    label: "Kansa",
  },
  {
    value: "KY",
    label: "Kentucky",
  },
  {
    value: "LA",
    label: "Lousiana",
  },
  {
    value: "ME",
    label: "Maine",
  },
  {
    value: "MD",
    label: "Maryland",
  },
  {
    value: "MA",
    label: "Massachusetts",
  },
  {
    value: "MI",
    label: "Michigan",
  },
  {
    value: "MN",
    label: "Minnesota",
  },
  {
    value: "MS",
    label: "Mississippi",
  },
  {
    value: "MO",
    label: "Missouri",
  },
  {
    value: "MT",
    label: "Montana",
  },
  {
    value: "NE",
    label: "Nebraska",
  },
  {
    value: "NV",
    label: "Nevada",
  },
  {
    value: "NH",
    label: "New Hampshire",
  },
  {
    value: "NJ",
    label: "New Jersey",
  },
  {
    value: "NM",
    label: "New Mexico",
  },
  {
    value: "NY",
    label: "New York",
  },
  {
    value: "NC",
    label: "North Carolina",
  },
  {
    value: "ND",
    label: "North Dakota",
  },
  {
    value: "OH",
    label: "Ohio",
  },
  {
    value: "OK",
    label: "Oklahoma",
  },
  {
    value: "OR",
    label: "Oregon",
  },
  {
    value: "PA",
    label: "Pennsylvania",
  },
  {
    value: "RI",
    label: "Rhode Island",
  },
  {
    value: "SC",
    label: "South Carolina",
  },
  {
    value: "SD",
    label: "South Dakota",
  },
  {
    value: "TN",
    label: "Tennessee",
  },
  {
    value: "TX",
    label: "Texas",
  },
  {
    value: "UT",
    label: "Utah",
  },
  {
    value: "VT",
    label: "Vermont",
  },
  {
    value: "VA",
    label: "Virginia",
  },
  {
    value: "WA",
    label: "Washington",
  },
  {
    value: "WV",
    label: "West Virginia",
  },
  {
    value: "WI",
    label: "Wisconsin",
  },
  {
    value: "WY",
    label: "Wyoming",
  },
];

export const purchasePackageList = [
  { id: "1", price: "00", label: "For District" },
  { id: "2", price: "00", label: "For School" },
  { id: "3", price: "00", label: "For Class" },
];

export const preferedPronounList = [
  { value: "1", label: "He/Him" },
  { value: "2", label: "She/Her" },
  { value: "3", label: "They/Them" },
];
export const subjectExpertiseList = [
  { value: "Math", label: "Math" },
  { value: "Science", label: "Science" },
  { value: "Social", label: "Social Studies/ History" },
  { value: "Language", label: "Language Arts/Literature" },
  { value: "ForeignLanguage", label: "Foreign Language" },
  { value: "Art", label: "Art" },
  { value: "Music", label: "Music" },
  { value: "Other", label: "Other" },
];
export const ageRangeList = [
  { label: "Under 30", value: 1 },
  { label: "30-40", value: 2 },
  { label: "Over 40", value: 3 },
];
export const gradesList = [
  { value: "Kindergarten", label: "Kindergarten" },
  { value: "1", label: "1st Grade" },
  { value: "2", label: "2nd Grade" },
  { value: "3", label: "3rd Grade" },
  { value: "4", label: "4th Grade" },
  { value: "5", label: "5th Grade" },
  { value: "6", label: "6th Grade" },
  { value: "7", label: "7th Grade" },
  { value: "8", label: "8th Grade" },
];
export const LanguageList = [
  { value: "0", label: "Afrikans" },
  { value: "1", label: "Albanian" },
  { value: "2", label: "Bulgarian" },
  { value: "3", label: "Chineese" },
  { value: "4", label: "Dutch" },
  { value: "5", label: "English" },
  { value: "6", label: "French" },
  { value: "7", label: "Georgian" },
  { value: "8", label: "Japaneese" },
  { value: "9", label: "Korean" },
];
export const EducatorYearsList = [
  { value: "0", label: "1-5" },
  { value: "1", label: "6-10" },
  { value: "2", label: "11-19" },
  { value: "3", label: "20+" },
];
export const educationList = [
  { value: "associate", label: "Associate Degree" },
  { value: "bachelor", label: "Bachelor's Degree" },
  { value: "master", label: "Master's Degree" },
  { value: "phd", label: "PhD" },
  { value: "others", label: "Others" },
];
export const planSubjectList = [
  { value: "1", label: "Language Arts" },
  { value: "2", label: "Math" },
  { value: "3", label: "Science" },
  { value: "4", label: "Social Studies" },
  { value: "5", label: "Cultures and Languages" },
];

export const MonthList = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];


// const months = month.getMonth() +1;

// export const Month

const year = new Date().getFullYear();
const years = Array.from(new Array(11), (val, index) => (year - 4) - index);

export const yearsList = years.map((year) => {
  return {
    label: year,
    value: year,
  };
});

export const paymentOptions = [
  { label: "Free Beta", id: 1 },
  { label: "Notify me every time", id: 2 },
];
export const foundOptions = [
  { label: "Advertisements", id: 2 },
  { label: "Social media", id: 3 },
  { label: "Teacher/School", id: 4 },
  { label: "Friend", id: 5 },
  { label: "Newsletter", id: 6 },
  { label: "Other", id: 1 },
];

export const childPlayOptions = [
  { label: "Only kids I approve", id: "approvedOnly" },
  { label: "Only kids in my child's grade and school", id: "sameSchool" },
  { label: "Only kids my child's age", id: "sameAge" },
  { label: "All kids on the site", id: "all" },
];

export const chatOptions = [
  { label: "Free-type", id: "freeType" },
  { label: "Pre-type", id: "preType" },
];

export const subscriptionOptions = [
  { label: "Beta is free to play!", id: "freetoPlay" },
];

export const perferneceOptions = [
  { label: "Easy", id: "easy" },
  { label: "Medium", id: "medium" },
  { label: "Challenging", id: "challenging" },
];

export const subjectOptions = [
  { label: "Art", value: "art" },
  { label: "Foreign Language", value: "foreignLanguage" },
  { label: "Language Arts/Literature", value: "languageArts" },
  { label: "Math", value: "math" },
  { label: "Science", value: "science" },
  { label: "Music", value: "music" },
  { label: "Social Studies/History", value: "socialStudies" },
  { label: "Others", value: "others" }
];

export const subjectOptionsInclAll = [
  { label: "All", value: "all"},
  { label: "Art", value: "art" },
  { label: "Foreign Language", value: "foreignLanguage" },
  { label: "Language Arts/Literature", value: "languageArts" },
  { label: "Math", value: "math" },
  { label: "Science", value: "science" },
  { label: "Music", value: "music" },
  { label: "Social Studies/History", value: "socialStudies" },
  { label: "Others", value: "others" }
];

export const allSubjectOptions = [
  { label: "Art", value: "art" },
  { label: "Foreign Language", value: "foreignLanguage" },
  { label: "Language Arts/Literature", value: "languageArts" },
  { label: "Math", value: "math" },
  { label: "Science", value: "science" },
  { label: "Music", value: "music" },
  { label: "Social Studies/History", value: "socialStudies" }
];

export const accountTypeList = [
  {
    label: "Individual Educator account",
    value: "teacherAccount",
    text: "To use in a single classroom and/or Submit content.",
  },
  {
    label: "Educator with School License Code",
    value: "schoolLicenseCode",
    text: "To create your School Educator account.",
  },
  {
    label: "School/District Administration",
    value: "school/district",
    text: "To create a School account with KazooBadoo.",
  },
];

export const teacherPlan = [
  { label: "Submit an Individual Lesson Plan", value: "lessonPlan" },
  { label: "Submit a Unit Plan", value: "unitPlan" },
];

export const wizardList = [
  {
    id: "/student",
    name: "Student",
    description:
      "This is where students who have received a school/class code or whose parents have signed them up, can sign in to play in the world of KazooBadoo and embark on our lesson quests.",
  },
  {
    id: "/parent",
    name: "Parent",
    description:
      "This registration section is for all parents. Parents create a Home Account and a sign-in for their children. Parents then link their child/children's accounts to the Home Account, manage their child/children's permissions, and receive reports about their experiences and data on their progress.",
  },
  {
    id: "/educator",
    name: "Educator",
    description:
      "This registration process is for teachers and school and district administrators who want to use KazooBadoo in their classrooms, and for all educators who want to submit lesson plans, upload teaching resources, or teach live sessions.  This is not for home-school parents. ",
  },
  {
    id: cleverUrl,
    name: "Clever",
    description: "Educator/Student can Login If has an account in Clever"
  },
  {
    id: baseUrl + 'users/googleClassAuthorize',
    name: "Google",
    description: `Educator/Student can Login If has an account in Google
    <br />
    <br />
    <span style="font-size: 14px; color: #33403E;">
        Kazoobadoo use and transfer of information received from Google APIs to any other app will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank" style="text-decoration: none; color: var(--kazoobadooTeal);">Google API Services User Data Policy</a>, including the Limited Use requirements.
    </span>
    `
  }
];

export const ALPHA_NUMERIC = "abcdefghijklmnopqrstuvwxyz0123456789";
export const USERNAME_CHAR_COUNT = 8;

export const USER_ACCT_TYPE_STUDENT = 'student';
export const USER_ACCT_TYPE_EDUCATOR = 'educator';
// export const WebsiteLink = "https://www.kazoobadoo.com/"
